import { useRoutes } from 'react-router-dom';

import { KakaoAuthInitialize } from 'utils/auth/kakao';

import GlobalProvider from 'components/provider/GlobalProvider';

import { routes } from 'routers';

function App() {
  const router = useRoutes(routes);
  // kakao login initialize
  KakaoAuthInitialize();

  return <GlobalProvider>{router}</GlobalProvider>;
}

export default App;
